import Header from "../../header/Header";
import AboutUs from "../about_info/AboutUs";
import Footer from "../../footer/Footer";

function AboutLanding() {
    return (
        <div className="about_landing">
            <Header />
            <AboutUs />
            <Footer />
        </div>
    )
}

export default AboutLanding